import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes,
    useState
} from "react";
import { Cancel, DangerSquare, Star } from "../../assets";
import LoadingSpinner from "./loading_spinner";
import CustomModal from "./modal";
interface Props extends HTMLAttributes<HTMLElement> {
    loading?:boolean;
    value: any;
    title?: string,
    onChange?: any;
    myStyle?: string;
    lable?: string;
    displayEmpty?: boolean;
    placeholder?: string;
    icon?: ReactElement;
    iconBorder?: boolean;
    hasNotice?: string;
    isRequired?: boolean;
    items?: any;
    error?: any;
    objectList?: boolean;
    contentLoading?: boolean;
    disabled?: boolean;
    hideWhenDisabled?: boolean; 
}

export function Dropdown({ value,loading, onChange, title, myStyle, lable, disabled , hideWhenDisabled,   displayEmpty, placeholder, icon, iconBorder, hasNotice, isRequired, items, error, objectList, contentLoading }: Props): ReactElement | null {
        const [openModal, setOpenModal] = useState(false);
        if (disabled && hideWhenDisabled) {
            return null; 
        }
    return (
        <div className={`${myStyle && myStyle} custom-dropdown`} >
            {lable &&
                <>
                    {contentLoading ?
                        <div className="input-loading-lable content-loading">
                        </div>
                        :
                        <label className="custom-dropdown-lable">
                            {isRequired && <img src={Star} alt="هامرز"/>}  {lable} 
                            {hasNotice && ( 
                                <img
                                    src={DangerSquare}
                                    alt="هامرز"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => setOpenModal(true)}  
                                />
                             )}

                        </label>
                    }
                </>
            }
                <FormControl className="dropdown" >
            {contentLoading ? <div className="content-loading w-100">
            </div> :
            <>
            {title && <InputLabel className="dropdown-title">{title}</InputLabel>}
                    <Select
                        value={value}
                        error={error ? true : false}

                        label={title ? title : ""}
                        displayEmpty={displayEmpty}
                        placeholder={placeholder ? placeholder : ""}
                        onChange={onChange}
                        className="dropdown-select"
                disabled={disabled && !error}

                        startAdornment={
                            icon &&
                            <InputAdornment position="end" >
                                {icon}
                                {iconBorder &&
                                    <div className="dropdown-select-icon-border">
                                    </div>
                                }
                            </InputAdornment>
                        }
                    >
                        <MenuItem disabled value="">
                        {placeholder}
                        </MenuItem>
                        {
                        loading ?
                        <div className="handle-loading-btn search-container-icon pt-2">
                        <LoadingSpinner />
                        </div>
                       
                    : 
                    items && items?.map((item: any, index: number) => {
                        return (
                            <MenuItem value={objectList ? item?.value : item} key={index}>{objectList ? item?.title : item}</MenuItem>
                        )
                    })
                    }
                    </Select>

                    {error &&
                        <label className="dropdown-select-error">
                            {error}
                        </label>
                    }
            </>
                   
                }
                </FormControl>
            <CustomModal myStyle="custom-input-modal" openModal={openModal} onClose={() =>setOpenModal(!openModal )}>
          <>
            <div className="custom-modal-main-title hide-desktop">
              <h1 className="title">
              {lable}              </h1>
              <Cancel myStyle="ps-2 " width="20" height="20" color="#000000" onClick={() =>setOpenModal(!openModal )} />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                {lable}
                </span>{" "}
              </div>
              <Cancel myStyle="hide-mobile cursor-pointer" onClick={() =>setOpenModal(!openModal )} />
            </div>
            
            <h2 className="custom-input-modal-info mt-33">
           {hasNotice}
            </h2>
          </>
        </CustomModal>
        </div>

    );
}

export default Dropdown;